// Mock Data 통합 관리
export { 
  mockExcelTemplates, 
  generateExcelTemplate,
  getTemplatesByType,
  getTemplateById,
  getPresetByName,
  paginateTemplates,
  addMockTemplate,
  updateMockTemplate,
  deleteMockTemplate,
  bulkDeleteMockTemplates
} from './excelTemplates.js';

// 환경 설정
export const MOCK_CONFIG = {
  // 환경별 Mock 사용 여부
  USE_EXCEL_TEMPLATE_MOCK: process.env.VUE_APP_USE_MOCK_EXCEL_TEMPLATES === 'true',
  USE_SETTLEMENT_MOCK: process.env.VUE_APP_USE_MOCK_SETTLEMENTS === 'true',
  USE_ALL_MOCK: process.env.VUE_APP_USE_MOCK_DATA === 'true',
  
  // API 응답 지연 시뮬레이션 (ms)
  MOCK_DELAY: parseInt(process.env.VUE_APP_MOCK_DELAY) || 300,
  
  // 페이지네이션 기본값
  DEFAULT_LIMIT: 10,
  DEFAULT_OFFSET: 0
};

// Mock 응답 지연 시뮬레이션
export function simulateApiDelay(delay = MOCK_CONFIG.MOCK_DELAY) {
  return new Promise(resolve => setTimeout(resolve, delay));
}

// Mock 응답 래퍼
export async function createMockResponse(data, options = {}) {
  const { 
    delay = MOCK_CONFIG.MOCK_DELAY,
    shouldFail = false,
    errorMessage = "Mock API Error"
  } = options;
  
  if (delay > 0) {
    await simulateApiDelay(delay);
  }
  
  if (shouldFail) {
    throw new Error(errorMessage);
  }
  
  return data;
}
